import React from "react";
import {
  Tabs,
  Tab
} from '@material-ui/core'
import PropTypes from 'prop-types';
import ToReview from './ToReview';
import ToPass from './ToPass';
import ToApprove from './ToApprove';
import ToPhysical from './ToPhysical';
import Sent from './Sent';
import Inbox from './Inbox';
import Sign from './Sign';
import Delegate from './containers/Delegate';
import Permissions from './Permissions';
import UserGroups from './containers/UserGroups';
import InboxIcon from "@material-ui/icons/Inbox";
import {
  DeviceHub,
  Send,
  Group } from "@material-ui/icons";
import { Permission } from "../img";
import { withStyles } from "@material-ui/core/styles";
import DelegateStore from '../stores/DelegateStore';
import UserStore from '../stores/UserStore';
import { PendingReview, PendingSign, SendSign, SendReview } from "../img";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          {children}
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function setIndex(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

const styles = theme => ({
  root:{
    backgroundColor: '#f1f1f1',
    color: '#393939',
    padding: 2,
    textTransform: 'capitalize',
    fontSize: 16,
    minHeight: 35,
    borderRadius: '5px 5px 0px 0px',
    width: 250,
    fontWeight: 'normal',
    "@media (max-width: 960px)": {
        fontSize: 12,
        width: 'auto',
        minHeight: 25,
        '& span': {
            '& svg':{
              display: 'none',
            },
        },
    },
    '&:hover':{
      opacity:1
    },
    '& span': {
      display: 'flex',
      flexDirection: 'inherit',
      alignContent: 'space-between',
      alignItems: 'center',
        '& svg':{
          width: '.7em'
        },
        '& span':{
          width: 'auto',
          padding: 0,
          marginLeft: 5
        }
    }
  },
  selected: {
    backgroundColor: '#8470a6',
    color: '#fff',
  },
});

export class GroupedMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      selectedTab: (typeof this.props.match.params.tab !== 'undefined')? Number(this.props.match.params.tab) : 0,
      page: (typeof this.props.match.params.page !== 'undefined')? Number(this.props.match.params.page) : 0,
      params: {
        ...UserStore.info(),
        hasDelegates: false,
        isDelegate: false,
        isReviewer: false
      }
    };
  }

  setParams = () => {

  //
    DelegateStore.getUsersOnBehalf().then(r => {
      if(r.data.length > 1){
        this.setState({ params: {...this.state.params, isDelegate: true } });
      }
      else{
        this.setState({ params: {...this.state.params, isDelegate: false } });
      }
    });

  //
    DelegateStore.listUsers('delegate').then(r => {
      if(r.data.length > 0){
        this.setState({ params: {...this.state.params, hasDelegates: true } });
      }
      else{
        this.setState({ params: {...this.state.params, hasDelegates: false } });
      }
    });

  //
    DelegateStore.getUsersOnBehalfReviewer().then(r => {
      if(r.data.length > 1){
        this.setState({ params: {...this.state.params, isReviewer: true } });
      }
      else{
        this.setState({ params: {...this.state.params, isReviewer: false } });
      }
    });
  }

  componentDidMount() {
    document.title = "GO | " + this.props.title;
    this.setParams();
  }

  changeTab = (event, tab) => {
    this.setState({ selectedTab: tab})
  }

  componentDidUpdate(prevPros, prevState){
    if(this.props.menu !== prevPros.menu){
      this.setParams();
      this.setState({ selectedTab: 0 })
    }
  }

  render() {

    const { selectedTab, params, page } = this.state
    const { menu, classes } = this.props
    let optionsTabs = null;
    let tabs = null;
    switch (menu) {

      case "Sent":
        //handle tabs
        let tab0 = 0
        let tab1 = 1
        let tab2 = 2

        if(params.needs_approval === 'true' && params.isDelegate === false){
          tab0 = 0
          tab1 = 2
          tab2 = 1
        }

        if(params.isDelegate === true && params.needs_approval === 'false'){
          tab0 = 2
          tab1 = 0
          tab2 = 1
        }

        if(params.isDelegate === false && params.needs_approval === 'false'){
          tab0 = 1
          tab1 = 2
          tab2 = 0
        }

        //options
        optionsTabs = [
            <Tab key={tab0} icon={<SendReview/>} label="Enviados a revisión" {...setIndex(tab0)}
            classes={{
              selected: classes.selected,
              root: classes.root
            }} />,
            <Tab key={tab1} icon={<SendSign/>} label="Enviados para firma" {...setIndex(tab1)}
            classes={{
              selected: classes.selected,
              root: classes.root
            }} />,
            <Tab key={tab2} icon={<Send/>} label="Enviados" {...setIndex(tab2)}
            classes={{
              selected: classes.selected,
              root: classes.root
            }} />]

            if(params.isDelegate === false && params.needs_approval === 'false'){
              delete optionsTabs[tab0]
              delete optionsTabs[tab2]
            }

            if(params.isDelegate === false && params.needs_approval !== 'false'){
              delete optionsTabs[tab2]
            }

            if(params.needs_approval === 'false' && params.isDelegate !== false){
              delete optionsTabs[tab1]
            }

        //tabs
        tabs = (
          <React.Fragment>
            <TabPanel value={selectedTab} index={tab0}>
              <ToApprove tab={selectedTab}/>
            </TabPanel>
            <TabPanel value={selectedTab} index={tab1}>
              <Sign tab={selectedTab}/>
            </TabPanel>
            <TabPanel value={selectedTab} index={tab2}>
              <Sent tab={selectedTab} page={page}/>
            </TabPanel>
          </React.Fragment>);

      break;
      case "Settings":
        //options
        optionsTabs = [
          <Tab key={0} icon={<Group/>} label="Grupos de usuario" {...setIndex(0)}
          classes={{
            selected: classes.selected,
            root: classes.root
          }} />,
            <Tab key={1} icon={<DeviceHub/>} label="Delegar" {...setIndex(1)}
            classes={{
              selected: classes.selected,
              root: classes.root
            }} />,
            <Tab key={2} icon={<Permission/>} label="Permisos" {...setIndex(2)}
            classes={{
              selected: classes.selected,
              root: classes.root
            }} />]

            if(params.can_create !== 'true'){
              delete optionsTabs[1]
            }

            if(params.can_grant !== 'true'){
              delete optionsTabs[2]
            }

        //tabs
        tabs = (
          <React.Fragment>
            <TabPanel value={selectedTab} index={0}>
              <UserGroups/>
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
              <Delegate />
            </TabPanel>
            <TabPanel value={selectedTab} index={2}>
              <Permissions can_grant={params.can_grant}/>
            </TabPanel>
          </React.Fragment>);
      break;

      default:
      // //handle tabs
      // let tabA = 2
      // let tabB = 3
      //
      //   //options
      //   optionsTabs = [
      //     <Tab key={0}  icon={<InboxIcon/>} label="Recibidos" {...setIndex(0)}
      //     classes={{
      //       selected: classes.selected,
      //       root: classes.root
      //     }} />,
      //     <Tab key={1} icon={<InboxIcon/>} label="Solicitud de oficio en físico" {...setIndex(1)}
      //     classes={{
      //       selected: classes.selected,
      //       root: classes.root,
      //     }} />,
      //     <Tab key={tabA}  icon={<PendingReview/>} label="Pendientes a revisión" {...setIndex(tabA)}
      //     classes={{
      //       selected: classes.selected,
      //       root: classes.root
      //     }} />,
      //     <Tab key={tabB} icon={<PendingSign/>} label="Pendientes de firma" {...setIndex(tabB)}
      //     classes={{
      //       selected: classes.selected,
      //       root: classes.root,
      //     }} />]
      //
      //     if(params.hasDelegates === false && params.is_supervisor === "false"){
      //       delete optionsTabs[tabA]
      //       delete optionsTabs[tabB]
      //     }
      //
      //     if(params.is_supervisor === "false" && params.hasDelegates === true){
      //       delete optionsTabs[tabB]
      //     }
      //
      //     if(params.hasDelegates === false && params.is_supervisor === "true"){
      //       delete optionsTabs[tabB]
      //     }
      //
      //   //tabs
      //   tabs = (
      //     <React.Fragment>
      //       <TabPanel value={selectedTab} index={0}>
      //         <Inbox tab={selectedTab} page={page}/>
      //       </TabPanel>
      //       <TabPanel value={selectedTab} index={1}>
      //         <ToPhysical tab={selectedTab}/>
      //       </TabPanel>
      //       <TabPanel value={selectedTab} index={tabA}>
      //         <ToPass tab={selectedTab}/>
      //       </TabPanel>
      //       <TabPanel value={selectedTab} index={tabB}>
      //         <ToReview tab={selectedTab}/>
      //       </TabPanel>
      //     </React.Fragment>);
      //handle tabs
     let tabA = 1
     let tabB = 2
     if(params.is_supervisor === "false" && params.hasDelegates === true){
       tabA = 2
       tabB = 1
     }
     if(params.hasDelegates === false && params.is_supervisor === "true"){
       tabA = 1
       tabB = 2
     }
       //options
       optionsTabs = [
         <Tab key={0}  icon={<InboxIcon/>} label="Recibidos" {...setIndex(0)}
         classes={{
           selected: classes.selected,
           root: classes.root
         }} />,
         <Tab key={tabA}  icon={<PendingReview/>} label="Pendientes a revisión" {...setIndex(tabA)}
         classes={{
           selected: classes.selected,
           root: classes.root
         }} />,
         <Tab key={tabB} icon={<PendingSign/>} label="Pendientes de firma" {...setIndex(tabB)}
         classes={{
           selected: classes.selected,
           root: classes.root,
         }} />]
         if(params.hasDelegates === false && params.is_supervisor === "false"){
           delete optionsTabs[tabA]
           delete optionsTabs[tabB]
         }
         if(params.is_supervisor === "false" && params.hasDelegates === true){
           delete optionsTabs[tabB]
         }
         if(params.hasDelegates === false && params.is_supervisor === "true"){
           delete optionsTabs[tabB]
         }
       //tabs
       tabs = (
         <React.Fragment>
           <TabPanel value={selectedTab} index={0}>
             <Inbox tab={selectedTab} page={page}/>
           </TabPanel>
           <TabPanel value={selectedTab} index={tabA}>
             <ToPass tab={selectedTab}/>
           </TabPanel>
           <TabPanel value={selectedTab} index={tabB}>
             <ToReview tab={selectedTab}/>
           </TabPanel>
         </React.Fragment>);
        break;
    }

    return (
      <React.Fragment>
        <Tabs value={selectedTab}
           scrollButtons="on"
           onChange={this.changeTab}
           aria-label="tabs">
           {optionsTabs}
        </Tabs>
          {tabs}
      </React.Fragment>
    );
  }
}

GroupedMenu.propTypes = {};
export default withStyles(styles)(GroupedMenu);



// WEBPACK FOOTER //
// ./src/components/GroupedMenu.js